import React from "react";
import { Box, Link } from "@mui/material";
import { colors, fonts, gradients, layout } from "../../theme/tokens";

const ctaImage =
  "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1200&auto=format&fit=crop";

const Book = () => {
  return (
    <Box
      component="section"
      sx={{ pt: "40px", pb: "86px", px: { xs: "20px", md: "28px" } }}
    >
      <Box
        sx={{
          maxWidth: layout.maxWidth,
          mx: "auto",
          position: "relative",
          borderRadius: "30px",
          overflow: "hidden",
          background: "linear-gradient(135deg,#1E3A57,#0E1B2A)",
        }}
      >
        <Box
          component="img"
          src={ctaImage}
          alt=""
          loading="lazy"
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.16,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "-90px",
            right: "-50px",
            width: "320px",
            height: "320px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle,rgba(246,166,35,.28),transparent 65%)",
          }}
        />
        <Box
          sx={{
            position: "relative",
            p: { xs: "40px 28px", md: "62px 56px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "40px",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ maxWidth: "620px" }}>
            <Box
              component="h2"
              sx={{
                fontFamily: fonts.display,
                fontWeight: 700,
                fontSize: "clamp(28px,3.6vw,42px)",
                lineHeight: 1.12,
                color: "#fff",
                letterSpacing: "-.02em",
                m: 0,
              }}
            >
              Ready to take your business forward?
            </Box>
            <Box
              sx={{
                fontFamily: fonts.body,
                fontSize: "16.5px",
                lineHeight: 1.65,
                color: colors.footerText,
                mt: "16px",
              }}
            >
              Connect with our team for a tailored consultation and discover how
              Argyle Consulting can help you achieve your goals.
            </Box>
          </Box>
          <Link
            href="/contact-us"
            underline="none"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flex: "none",
              background: gradients.amber,
              color: "#fff",
              fontFamily: fonts.body,
              fontWeight: 700,
              fontSize: "16px",
              p: "17px 34px",
              borderRadius: "46px",
              boxShadow: "0 16px 36px -14px rgba(242,121,28,.7)",
              transition: "transform .25s ease",
              "&:hover": { transform: "translateY(-1px)" },
            }}
          >
            Get in touch{" "}
            <Box component="span" sx={{ fontSize: "19px" }}>
              →
            </Box>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Book;
